import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Kontakt from "../pages/kontakt/page";
import Photovoltaik from "../pages/photovoltaik/page";
import Stromspeicher from "../pages/stromspeicher/page";
import Wallbox from "../pages/wallbox/page";
import G2Contracting from "../pages/g2-contracting/page";
import G2Leistungen from "../pages/g2-contracting/leistungen/page";

import SmartHome from "../pages/smart-home/page";
import ECheck from "../pages/e-check/page";
import Notstrom from "../pages/notstrom/page";
import UeberUns from "../pages/ueber-uns/page";
import Karriere from "../pages/karriere/page";
import Referenzen from "../pages/referenzen/page";
import Waermepumpe from "../pages/waermepumpe/page";
import Einfamilienhaus from "../pages/einfamilienhaus/page";
import Mehrfamilienhaus from "../pages/mehrfamilienhaus/page";
import Gewerbe from "../pages/gewerbe/page";
import Landwirtschaft from "../pages/landwirtschaft/page";
import Impressum from "../pages/impressum/page";
import Datenschutz from "../pages/datenschutz/page";
import AGB from "../pages/agb/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kontakt",
    element: <Kontakt />,
  },
  {
    path: "/photovoltaik",
    element: <Photovoltaik />,
  },
  {
    path: "/stromspeicher",
    element: <Stromspeicher />,
  },
  {
    path: "/wallbox",
    element: <Wallbox />,
  },
  {
    path: "/g2-contracting",
    element: <G2Contracting />,
  },
  {
    path: "/g2-contracting/leistungen",
    element: <G2Leistungen />,
  },

  {
    path: "/smart-home",
    element: <SmartHome />,
  },
  {
    path: "/e-check",
    element: <ECheck />,
  },
  {
    path: "/notstrom",
    element: <Notstrom />,
  },
  {
    path: "/ueber-uns",
    element: <UeberUns />,
  },
  {
    path: "/karriere",
    element: <Karriere />,
  },
  {
    path: "/referenzen",
    element: <Referenzen />,
  },
  {
    path: "/waermepumpe",
    element: <Waermepumpe />,
  },
  {
    path: "/einfamilienhaus",
    element: <Einfamilienhaus />,
  },
  {
    path: "/mehrfamilienhaus",
    element: <Mehrfamilienhaus />,
  },
  {
    path: "/gewerbe",
    element: <Gewerbe />,
  },
  {
    path: "/landwirtschaft",
    element: <Landwirtschaft />,
  },
  {
    path: "/impressum",
    element: <Impressum />,
  },
  {
    path: "/datenschutz",
    element: <Datenschutz />,
  },
  {
    path: "/agb",
    element: <AGB />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
